import { useCurrentUser } from './hooks';

export function BannedPage() {
  const me = useCurrentUser();
  return (
    <div
      style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#1a0e0e',
        color: '#e7c0c0',
        fontFamily: 'Georgia, serif',
      }}
    >
      <div style={{ maxWidth: 460, padding: 24, textAlign: 'center' }}>
        <h2 style={{ fontSize: 24, fontWeight: 400 }}>
          The forest has closed to you.
        </h2>
        <p style={{ opacity: 0.75, fontStyle: 'italic', marginTop: 12 }}>
          {me?.name ?? 'This identity'} can no longer enter the canopy.
        </p>
        {/* No reason field surfaced to user yet — admin tooling can decide
            later whether/how to expose ban_reason. */}
      </div>
    </div>
  );
}
